import React from 'react'
import cx from 'classnames'
import YouTube from 'react-youtube'
import styles from './video-player.module.scss'
import { CoverImage } from '../image'
import { MarqueeV2 as Marquee } from '../marquee'

export default function VideoPlayer({
  youtubeId,
  cover,
  onRequestPlay,
  covered = true,
}) {
  const [ytapi, setYouTubeAPI] = React.useState(null)
  React.useEffect(() => {
    if (!ytapi) return
    if (covered) ytapi.pauseVideo()
    else setTimeout(() => ytapi.playVideo(), 1000)
  }, [covered, ytapi])
  return (
    <div
      className={cx(styles.player, {
        [styles.covered]: covered,
      })}
    >
      <YouTube
        className={styles.player__embed}
        videoId={youtubeId}
        opts={{
          height: '315',
          width: '560',
          playerVars: {
            autoplay: 1,
            modestbranding: 1,
            rel: 0,
          },
        }}
        onReady={e => setYouTubeAPI(e.target)}
      />
      <div className={styles.player__cover}>
        <CoverImage fluid={cover.fluid} alt={cover.description} />
        <PlayButton onClick={onRequestPlay} className={styles.player__button} />
        <div className={styles.player__ticker}>
          <Marquee duration="15s" pauseOnHover={false}>
            <div className={styles.marquee}>
              <div>Click-2-Watch 👀&nbsp;</div>
              <div>Click-2-Watch 👀&nbsp;</div>
              <div>Click-2-Watch 👀&nbsp;</div>
              <div>Click-2-Watch 👀&nbsp;</div>
            </div>
          </Marquee>
        </div>
      </div>
    </div>
  )
}

VideoPlayer.YoutubeURLToId = url => {
  let match = url.match(/youtu\.be\/(.+)/)
  if (match) return match[1]
  match = url.match(/v=(\w+)/)
  if (match) return match[1]
  return ''
}

function PlayButton({ ...props }) {
  return (
    <button type="button" {...props}>
      <svg
        width="104"
        height="104"
        viewBox="0 0 104 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M102.755 51.7456C102.755 79.9171 79.9171 102.755 51.7456 102.755C23.5741 102.755 0.736638 79.9171 0.736638 51.7456C0.736638 23.5741 23.5741 0.736638 51.7456 0.736638C79.9171 0.736638 102.755 23.5741 102.755 51.7456Z"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.47328"
        />
        <path
          d="M38.1934 78.2349L74.5385 50.514L38.1934 22.7931L38.1934 50.514L38.1934 78.2349Z"
          fill="currentColor"
        />
      </svg>
    </button>
  )
}
